import { GodziDropResultType, SlotVoucherSummary } from '@slot-nx/core'
import { SymbolData } from './SymbolData'
import { SymbolType } from '../enum/SymbolType'

export interface WinLine {
  type: SymbolType
  count: number
  payout: number
  removedPositions: number[][]
  winPositions: number[][]
}

export interface Position {
  x: number
  y: number
}

export interface GiftedSymbol {
  position: Position
  newSymbol: SymbolData
}

export interface Multiplier {
  position: Position
  multiplier: number
}

export interface Drop {
  dropTable: SymbolData[][]
  finalTable: SymbolData[][]
  winLineList: WinLine[]
  payout: number
  totalWinPositions: number[][]
  giftedSymbols: GiftedSymbol[]
  expandingSymbols: SymbolData[][]
  isExpanding: boolean
  isGiveWild: boolean
  isGiveMultiplier: boolean
}

export interface PotAction {
  type: PotType
  from: number
  to: number
}

export interface MGResult {
  dropList: Drop[]
  betLevel: number
  odds: number
  basePayout: number
  payout: number
  playStake: number
  freeGameType: FreeGameType
  fgAddTimes: number
  potActionList: PotAction[]
  multiplierList: Multiplier[]
  spinMultiplier: number
  totalMultiplier: number
  accMultiplier: number
}

export interface GameResult {
  fgPayout: number
  totalPayout: number
  mgResult: MGResult
  fgResultList: MGResult[]
}

export interface GameResponse {
  balance: number
  gameResult: GameResult
  godziDropDetail: GodziDropResult
  message: string
  refNo: string
  returnCode: number
  slotVoucherSummary: SlotVoucherSummary
}

// ------------------- godziDropDetail -------------------
export declare interface GodziDropResult {
  effectiveStake: number
  freeSpinCount: number
  gameResultList: GameResult[]
  payout: number
  prize: number
  type: GodziDropResultType
  winLose: number
}

export enum FreeGameType {
  None = 0,
  expend = 1,
  wild = 2,
  multiplier = 3,
  wildExpend = 4,
  expendMultiplier = 5,
  multiplierWild = 6,
  wildExpendMultiplier = 7,
}

export enum PotType {
  Expanding1 = 1,
  Wild2 = 2,
  Multiplier3 = 3,
}

export const FREE_GAME_SYMBOL_MAP: Record<FreeGameType, number[]> = {
  [FreeGameType.None]: [],
  [FreeGameType.expend]: [66],
  [FreeGameType.wild]: [88],
  [FreeGameType.multiplier]: [77],
  [FreeGameType.wildExpend]: [66, 88],
  [FreeGameType.expendMultiplier]: [66, 77],
  [FreeGameType.multiplierWild]: [77, 88],
  [FreeGameType.wildExpendMultiplier]: [66, 77, 88],
}
